import { Component } from '@angular/core';

@Component({
    template: require('./home.component.html')
})
export class HomeComponent {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/home/home.component.ts
 **/